exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IffOaqUgHdZ-Mic1KMXmx{max-width:640px;margin:0 auto;width:100%}\n", ""]);
// Exports
exports.locals = {
	"userData": "IffOaqUgHdZ-Mic1KMXmx"
};